import type { DependencyList } from 'react';
import { useEffect } from 'react';
import useLoadTracker from './useLoadTracker';

export default function useLoadingEffect(effect: () => Promise<void>, deps?: DependencyList) {
	const loadTracker = useLoadTracker();

	useEffect(() => {
		const loader = loadTracker.addLoader();

		effect().finally(() => {
			loadTracker.removeLoader(loader);
		});

		return () => {
			loadTracker.removeLoader(loader);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, deps);

	return loadTracker.isLoading;
}
